














import {Component, Vue} from 'vue-property-decorator';
import DynamicComponents from '@/components/DynamicComponents.vue';
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import {SAddComponentFormValue} from '@/components/dto/SAddComponentFormValue';
import {SAddComponentFormValueImpl, SAddComponentImpl} from '@/components/dto/SAddComponentFormValueImpl';
import {SFormSelectOptions} from '@/components/dto/SFormSelectOptions';
import {ScomponentMode} from '@/components/dto/ScomponentMode';
import {ScomponentModeImpl} from '@/components/dto/ScomponentModeImpl';
@Component({
    components: {DynamicComponents}
})
export default class AddComponents extends Vue {

    private schema: SDynamicComponent[] = this.formSchema();
    private data: SAddComponentFormValue = SAddComponentFormValueImpl.prototype.empty();
    private mode: ScomponentMode = ScomponentModeImpl.prototype.empty();

    handle_function_call(e: any) {
        //@ts-ignore
        this[e]();
    };


    addComponent(){
        let add = new SAddComponentImpl(this.data);
        this.$store.dispatch('addcomponent', add).then(() => {
            return this.data = SAddComponentFormValueImpl.prototype.empty();
        }).catch(err => {
            console.log(err);
        });
    }

    createOptionsComponentTypes(): SFormSelectOptions[]{
        let componentTypes: SFormSelectOptions[] = [{value: '', text: ''}];
        this.$store.dispatch('loadComponentTypes').then(types => {
            //@ts-ignore
            types.data.forEach(item =>{
                let type:SFormSelectOptions = {value: item.name, text: this.$i18n.t('componentTypes.'+item.name)};
                componentTypes.push(type);
            })
        }).catch(err => {
            console.log(err);
        });

        return componentTypes;
    }

    createOptionsComponentGroup(): SFormSelectOptions[]{
        let componentGroups: SFormSelectOptions[] = [{value: '', text: ''}];
        this.$store.dispatch('loadComponentGroups').then(types => {
            //@ts-ignore
            types.data.forEach(item =>{
                let type:SFormSelectOptions = {value: item.name, text: this.$i18n.t('componentGroup.'+item.name)};
                componentGroups.push(type);
            })
        }).catch(err => {
            console.log(err);
        });

        return componentGroups;
    }


    formSchema() : SDynamicComponent[]{
        return [
            {
                "component": {
                    "uid": "",
                    "name": "Container",
                    "url": "http://localhost:5000/container.umd.min.js"
                },
                "data": {
                    "body": [
                        {
                            "component": {
                                "uid": "",
                                "name": "Form",
                                "url": "http://localhost:5000/form.umd.min.js"
                            },
                            "data": {
                                "body": [{
                                    "component": {
                                        "uid": "",
                                        "name": "Card",
                                        "url": "http://localhost:5000/card.umd.min.js"
                                    },
                                    "data": {

                                        "title": "Add new component",
                                        "classes": "mb-2",
                                        "styles": "margin-top: 20px",
                                        "body": [
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormGroup",
                                                    "url": "http://localhost:5000/form-group.umd.min.js"
                                                },

                                                "data": {
                                                    "id": "fieldset-name",
                                                    "label": "Component name:",
                                                    "label_cols_sm":1,
                                                    "label_cols_lg":2,
                                                    "label_for": "name",
                                                    "body":[
                                                        {
                                                            "component": {
                                                                "uid": "",
                                                                "name": "FormInput",
                                                                "url": "http://localhost:5000/form-input.umd.min.js"
                                                            },
                                                            "data": {
                                                                "id": "name",
                                                                "name": "name_",
                                                                "required": true,
                                                                "body":[]
                                                            },
                                                            "componentMode":{
                                                                "editable":false,
                                                                "delete":false,
                                                                "addHint":false,
                                                                "moveComponent":false
                                                            }
                                                        }
                                                    ]
                                                },
                                                "componentMode":{
                                                    "editable":false,
                                                    "delete":false,
                                                    "addHint":false,
                                                    "moveComponent":false
                                                }
                                            },
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormGroup",
                                                    "url": "http://localhost:5000/form-group.umd.min.js"
                                                },

                                                "data": {
                                                    "id": "fieldset-version",
                                                    "label": "Component version:",
                                                    "label_cols_sm":1,
                                                    "label_cols_lg":2,
                                                    "label_for": "version",
                                                    "body":[
                                                        {
                                                            "component": {
                                                                "uid": "",
                                                                "name": "FormInput",
                                                                "url": "http://localhost:5000/form-input.umd.min.js"
                                                            },
                                                            "data": {
                                                                "id": "version",
                                                                "name": "version_",
                                                                "required": true,
                                                                "body":[]
                                                            },
                                                            "componentMode":{
                                                                "editable":false,
                                                                "delete":false,
                                                                "addHint":false,
                                                                "moveComponent":false
                                                            }
                                                        }
                                                    ]
                                                },
                                                "componentMode":{
                                                    "editable":false,
                                                    "delete":false,
                                                    "addHint":false,
                                                    "moveComponent":false
                                                }
                                            },
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormGroup",
                                                    "url": "http://localhost:5000/form-group.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "fieldset-component-type",
                                                    "label": "Component type:",
                                                    "label_cols_sm":1,
                                                    "label_cols_lg":2,
                                                    "label_for": "component_type",
                                                    "body":[
                                                        {
                                                            "component": {
                                                                "name": "FormSelect",
                                                                "url": "http://localhost:5000/form-select.umd.min.js"
                                                            },
                                                            "data": {
                                                                "id": "component_type",
                                                                "name": "component_type_",
                                                                "options": this.createOptionsComponentTypes(),
                                                                "body":[]
                                                            },
                                                            "componentMode":{
                                                                "editable":false,
                                                                "delete":false,
                                                                "addHint":false,
                                                                "moveComponent":false
                                                            }
                                                        }
                                                    ]
                                                },
                                                "componentMode":{
                                                    "editable":false,
                                                    "delete":false,
                                                    "addHint":false,
                                                    "moveComponent":false
                                                }
                                            },
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormGroup",
                                                    "url": "http://localhost:5000/form-group.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "fieldset-component-type",
                                                    "label": "Component group:",
                                                    "label_cols_sm":1,
                                                    "label_cols_lg":2,
                                                    "label_for": "component_group",
                                                    "body":[
                                                        {
                                                            "component": {
                                                                "name": "FormSelect",
                                                                "url": "http://localhost:5000/form-select.umd.min.js"
                                                            },
                                                            "data": {
                                                                "id": "component_group",
                                                                "name": "component_group_",
                                                                "options": this.createOptionsComponentGroup(),
                                                                "body":[]
                                                            },
                                                            "componentMode":{
                                                                "editable":false,
                                                                "delete":false,
                                                                "addHint":false,
                                                                "moveComponent":false
                                                            }
                                                        }
                                                    ]
                                                },
                                                "componentMode":{
                                                    "editable":false,
                                                    "delete":false,
                                                    "addHint":false,
                                                    "moveComponent":false
                                                }
                                            },
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormGroup",
                                                    "url": "http://localhost:5000/form-group.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "fieldset-add-component",
                                                    "label": "Add new json component:",
                                                    "label_cols_sm":1,
                                                    "label_cols_lg":2,
                                                    "label_for": "component",
                                                    "body":[
                                                        {
                                                            "component": {
                                                                "uid": "",
                                                                "name": "FormTextarea",
                                                                "url": "http://localhost:5000/form-textarea.umd.min.js"
                                                            },
                                                            "data": {
                                                                "id": "component",
                                                                "name": "component_",
                                                                "required": true,
                                                                "rows": 6,
                                                                "placeholder": "Add json component"
                                                            },
                                                            "componentMode":{
                                                                "editable":false,
                                                                "delete":false,
                                                                "addHint":false,
                                                                "moveComponent":false
                                                            }
                                                        }
                                                    ]
                                                },
                                                "componentMode":{
                                                    "editable":false,
                                                    "delete":false,
                                                    "addHint":false,
                                                    "moveComponent":false
                                                }
                                            },
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "Row",
                                                    "url": "http://localhost:5000/row.umd.min.js"
                                                },
                                                "data": {
                                                    "align_h": "end",
                                                    "align_v": "center",
                                                    "align_content": "center",
                                                    "body": [
                                                        {
                                                            "component": {
                                                                "uid": "",
                                                                "name": "Button",
                                                                "url": "http://localhost:5000/button.umd.min.js"
                                                            },
                                                            "data": {
                                                                "button_text": "Add new component",
                                                                "variant": "primary",
                                                                "type": "submit",
                                                                "size": "",
                                                                "fn_name": "addComponent"
                                                            },
                                                            "componentMode":{
                                                                "editable":false,
                                                                "delete":false,
                                                                "addHint":false,
                                                                "moveComponent":false
                                                            }
                                                        }
                                                    ]
                                                },
                                                "componentMode":{
                                                    "editable":false,
                                                    "delete":false,
                                                    "addHint":false,
                                                    "moveComponent":false
                                                }
                                            }

                                        ],
                                    },
                                    "componentMode":{
                                        "editable":false,
                                        "delete":false,
                                        "addHint":false,
                                        "moveComponent":false
                                    }
                                }]
                            },
                            "componentMode":{
                                "editable":false,
                                "delete":false,
                                "addHint":false,
                                "moveComponent":false
                            }
                        }
                    ]
                },
                "componentMode":{
                    "editable":false,
                    "delete":false,
                    "addHint":false,
                    "moveComponent":false
                }
            }
            ]
    }

}
